// src/plugins/vuetify.ts
import 'vuetify/styles'; // Import Vuetify styles
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { es } from 'vuetify/locale'; // Import Spanish locale

// Import your SCSS variables
import '../styles/variables.scss';
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi', // Material Design Icons as the default set
    aliases,
    sets: {
      mdi,
    },
  },
  locale: {
    locale: 'es', // Set Spanish as the default language
    fallback: 'en', // Fallback to English if a translation is missing
    messages: { es }, // Register the Spanish messages
  },
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#6200EA',
          secondary: '#03DAC6',
          accent: '#FF4081',
        },
      },
      dark: {
        colors: {
          primary: '#2563EB',
          secondary: '#03DAC6',
          accent: '#FF4081',
          sidebar: '#0b0b0d',
          background:'#09090B',
          error:'#DC2626',
          black:'#000',
          b0:'#09090B',
          b1:'#18181B',
          b2:'#27272A'
        },
      },
    },
  },
});

export default vuetify;
